// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-wrapper .min-height{height:10vh}.login-wrapper .full-height{height:100vh}", "",{"version":3,"sources":["webpack://./src/containers/LoginWrapper/index.scss"],"names":[],"mappings":"AACE,2BACE,WAAA,CAEF,4BACE,YAAA","sourcesContent":[".login-wrapper {\n  .min-height {\n    height: 10vh;\n  }\n  .full-height {\n    height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
